function getUserId(globalVar) {
  return (
    // essos page
    (globalVar && globalVar.USER && globalVar.USER.id) ||
    // mothership page
    (globalVar &&
      globalVar.blGlobal &&
      globalVar.blGlobal.user &&
      globalVar.blGlobal.user.id) ||
    // default
    ''
  );
}

export default getUserId;
